import {Observable} from 'rxjs';
import {marineHubAPI} from "../provider/marineHubAPI";
import {RestQueryParams} from "../base/queryParams";
import {IUpdateOperatorFullAccountPayload} from "../../store/reducers/accountSlice";


export function updateOperatorFullAccountAPI(
    authToken: string | null,
    accountId: string,
    payload: IUpdateOperatorFullAccountPayload,
): Observable<any> {
    let headers = undefined;

    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    return marineHubAPI.put(`api/accounts/${accountId}/change_operator_full_info`, payload, new RestQueryParams(), headers);
}
